export const APP_TITLE = 'MCANISM SKYNET';
export const FALLBACK_BACKGROUND_IMAGE = '/assets/img/fallback-campaign.png';
